import * as React from 'react';
import { useState, useEffect } from 'react';

import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { HardwareModelFilterRequest } from '../../services/service'
import { FormDialog } from '../../components/FormDialog';
import { APISelectField } from '../APISelectField';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';


export default function HardwareModelFilter(props) {
  const { tableData, childrenToParentValue } = props
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [hardwareManufacturer, setHardwareManufacturer] = useState('');
  const [hardwareArch, setHardwareArch] = useState('');
  const [uniqManufacturer, SetUniqManufacturer] = useState([]);
  const [filtersState, setFiltersState] = React.useState(false);

  const handleChangeManufacturer = (event) => {
    setHardwareManufacturer(event.target.value);
  };
  const handleChangeArch = (event) => {
    setHardwareArch(event.target.value);
  };

  const filterRequest = () => {
    HardwareModelFilterRequest(hardwareManufacturer, hardwareArch).then((resp) => {
      childrenToParentValue(resp.data)
      setOpen(false)
      setFiltersState(true)
    })
  }
  var resArr = [];
  useEffect(() => {
    console.log(tableData)
    tableData.results.filter((item) => {
      var i = resArr.findIndex(x => (x.manufacturer === item.manufacturer));
      if (i <= -1) {
        resArr.push(item);
      }
      return null;
    });
    SetUniqManufacturer(resArr)
  }, [tableData])

  const clearFilter = () => {
    HardwareModelFilterRequest('', '').then((resp) => {
      childrenToParentValue(resp.data)
      setOpen(false)
      setFiltersState(false)
      setHardwareManufacturer('')
      setHardwareArch('')
    })
  }

  return (
    <div>
      <Row>
        <Col sm={1}>
          <Button variant="outlined" onClick={handleClickOpen}>
            Filtrar
          </Button>
        </Col>
        {
          filtersState
            ? (
              <Col sm={2}>
                <Button variant="outlined" color="error" onClick={clearFilter} type='submit' >
                  Limpar Filtro
                </Button>
              </Col>
            )
            : null
        }
      </Row>
      <FormDialog
        title={"Selecione os filtros desejados"}
        open={open}
        onDismiss={handleClose}
        formWidth={350}
        onSubmit={() => filterRequest()}
      >
        <APISelectField
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={hardwareManufacturer}
          onChange={handleChangeManufacturer}
          label="Fabricante"
        >
          <MenuItem value="">
            <em>Todas</em>
          </MenuItem>
          {
            uniqManufacturer.map((e) => 
              <MenuItem key={e.manufacturer} value={e.manufacturer}>{e.manufacturer}</MenuItem>
            )
          }
        </APISelectField>
        <APISelectField
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={hardwareArch}
          onChange={handleChangeArch}
          label="Arquitetura"
        >
          <MenuItem value="">
            <em>Todas</em>
          </MenuItem>
          <MenuItem value={'x86-64'}>{'x86-64'}</MenuItem>
          <MenuItem value={'armhf'}>{'armhf'}</MenuItem>
          <MenuItem value={'armv7'}>{'armv7'}</MenuItem>
        </APISelectField>
      </FormDialog>
    </div>
  );
}